import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { UserLoginImplementation } from '@commoncore/implementation/UserLoginImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { EmailVerificationImplementation } from '@mainrepo/app/core/implementation/email-verification-implementation';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';



const emailRegex = "^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$";

//const regexpEmail =  new RegExp("^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" );

//const regexpEmail2 =  new RegExp("^[a-zA-Z0-9_]+([\.-]?[a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([\.-]?[a-zA-Z0-9_]+)*(\.[a-zA-Z0-9]{2,3})+$" );
const regexpEmail = /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{1,50})\.\50)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/;
const regexpMobile = /^(\+)?[0-9]+$/;

@Component({
  standalone:true,
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css'],
  imports:[DependenciesModule]
})
export class EmailVerificationComponent implements OnInit, AfterViewInit {

  
  userLoginController: UserloginController ;
  implRef: EmailVerificationImplementation;
  userData: any;
  loginImplRef:UserLoginImplementation;
  emailVerified:boolean = true;
  showValidateEmailScreen: boolean = true;
  showInputOtpScreen: boolean = false;
  userEmail: FormControl = new FormControl('', [Validators.required] );
  // userMobile: FormControl = new FormControl('', [Validators.required] );
  otp:string;
  public userMobileForm = new FormGroup({
    userMobile: new FormControl("")
  });
  cleverTapEventsService:any
   //,Validators.pattern("^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$")
  emailPattern:boolean = false;
  mobilePattern:boolean = false;
  inputInvalid:boolean = true;

  maxLen:any = 100
  errorMsg:any = "";
 @ViewChild('emailInput', {static:false}) emailInput: ElementRef;
 @ViewChild('mobileInput', {static:false}) mobileInput: ElementRef;
  recalculateHeightService: any;
  
  constructor(private globalService: GlobalService, private localStorageSvc: LocalStorageSvc,public universalService:UniversalService) {
    this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
    this.recalculateHeightService = globalService.getContainerHeightCalculatorService();
   }

   @HostListener('document:keydown', ['$event'])
   onKeyDownHandler(event: KeyboardEvent) {
     if (event.key === "Escape" && this.universalService.isShowEmailVerifyModal) {
        if(this.implRef.isMandatoryEmailActive) {
          event.stopImmediatePropagation();
          return false;
        } else {
          this.closeEmailVerifyModal();
        }
     }
   }
  ngOnInit(): void {
    const userData = this.localStorageSvc.getUserData(true);
    this.userData = userData;
    this.userLoginController=UserloginController.getInstance(this.globalService);
    this.loginImplRef = this.userLoginController.userLoginImplementation;
    this.implRef = EmailVerificationImplementation.getInstance(this.globalService);
    this.implRef.loginImpl = this.loginImplRef;
    if(!this.universalService.inAppWebViewOpened) {
      this.registeringevents();
      this.verifyEmail();
    }
  }

  private registeringevents(){
    AppEvents.on(EventsList.SHOW_EMAIL_VERIFIACTION_MODAL_FOR_PROFILE, async ()=> {
      this.universalService.popUpToBeOpened = "dummy";
      this.universalService.isShowEmailVerifyModal  = true;
      this.universalService.isPhoneVerification = false;
      this.setNecessaryDataForVerification();
    });
    AppEvents.on(EventsList.SHOW_EMAIL_VERIFIACTION_MODAL_FOR_BACKUP_NO_PROFILE, async ()=> {
      this.universalService.popUpToBeOpened = "dummy";
      this.universalService.isShowEmailVerifyModal  = true;
      this.universalService.isPhoneVerification = true;
      this.setNecessaryDataForVerification();
    })
  }

  async ngAfterViewInit(){
    this.setNecessaryDataForVerification();
    setTimeout(() => { 
      this.recalculateHeightService.sendRecalculateEventToComponents(true);
    }, 2000);
  }
  async setNecessaryDataForVerification(){
    setTimeout(async ()=>{
      const userData = this.localStorageSvc.getUserData(true);
      this.userData = userData;
      if(this.universalService.mobileNoVerification){
        if(userData){
          let mobNo= userData.mobileNumber? userData.mobileNumber : '';
          if(mobNo.toString().slice(0,1)=='+'){
            mobNo = mobNo.substring(3)
          }
          this.loginImplRef.enableButton = true;
          this.implRef.mobileNo = mobNo ? mobNo : '';
          let el = document.getElementById('user-no-txtbx')as any;
          el.value = this.implRef.mobileNo;
          this.userMobileForm.get('userMobile').setValue(this.implRef.mobileNo.toString());
          await this.onLoading(this.implRef.mobileNo,'mobile')
        }
      }else if(this.universalService.backupNoVerification){
        if(userData){
          let mobNo= userData.backupMobileNumber? userData.backupMobileNumber : '';
          if(mobNo.toString().slice(0,1)=='+'){
            mobNo = mobNo.substring(3)
          }
          this.loginImplRef.enableButton = true;
          this.implRef.mobileNo = mobNo ? mobNo : '';
          let el = document.getElementById('user-no-txtbx')as any;
          el.value = this.implRef.mobileNo;
          this.userMobileForm.get('userMobile').setValue(this.implRef.mobileNo.toString());
          await this.onLoading(this.implRef.mobileNo,'mobile')
        }
      }else{
        if(userData && userData.emailId){
          this.loginImplRef.enableButton = true;
          this.implRef.emailId = userData.emailId ? userData.emailId : '';
          let el = document.getElementById('email-txtbx')as any;
          el.value = this.implRef.emailId;
          this.userEmail.setValue(this.implRef.emailId);
          await this.onLoading(this.implRef.emailId,'email');
        }
      }
    },300)
  }
  verifyEmail(){
    const userData = this.localStorageSvc.getUserData(true);
    this.implRef.userData = userData;
    this.emailVerified = userData.isEmailIdVerified;
    if( userData && userData.isEmailIdVerified == false){
      this.implRef.checkEmailVerificationBannerStatus(userData);
    }else if(userData && userData.isEmailIdVerified == true) {
      this.implRef.showVerificationBanner = false;
      if(userData.authProviderId == 2 || userData.authProviderId  == 3 || userData.authProviderId  == 5){
        this.universalService.socialEmailAlreadyVerified = true;
        if(userData.isNewUserNotify == 'Y' && !userData.isMobileNumVerified){
          this.universalService.mobileNoVerification = true;
          this.universalService.isPhoneVerification = true;
          AppEvents.emit(EventsList.SHOW_EMAIL_VERIFIACTION_MODAL_FOR_BACKUP_NO_PROFILE);
        }
      }else{
        this.universalService.socialEmailAlreadyVerified = false;
      }
    }
     
  }

  verifyNow(){
    this.hideEmailVerificationBanner();
    this.cleverTapEventsService.emailBannerClicked();
    this.implRef.showValidateEmailScreen = true;
    this.implRef.showInputOtpScreen = false;
    this.showEmailVerifyModal();
  }

  validateOTP(fromId, toId, e) {
    this.userLoginController.setEnvObjects(this.globalService);
    this.userLoginController.otpValidation(fromId, toId, e);
    this.implRef.enableButton = this.loginImplRef.enableButton;
  }


 
  sendEmailVerificationOtp(type){
    if(type == 'email'){
      let el = document.getElementById('email-txtbx')as any;
      let value = el.value;
      if(regexpEmail.test(value)){
        this.implRef.sendEmailVerificationOtp( value,type);
      }
    }else{
      let el = document.getElementById('user-no-txtbx')as any;
      let value = el.value;
      if(regexpMobile.test(value)){
        this.implRef.sendEmailVerificationOtp(value,type);
      }
    }
  }
  

  resendEmailVerifyOtp(type){
    this.implRef.isResendEmailOtp = true;
    this.sendEmailVerificationOtp(type);
  }

  verifyEmailVerificationOTP(type){
    const otpInputs = document.getElementsByName("otpdigit[]") as any;
    let otp = "";
    for (var i = 0; i < otpInputs.length; i++) {
      otp = otp ? otp + otpInputs[i].value: otpInputs[i].value;
    }
    this.otp = otp;
    if(type == 'email'){
      this.implRef.verifyEmailVerificationOTP(this.userEmail.value, this.otp,type);
    }else{
      let el = document.getElementById('user-no-txtbx')as any;
      let value = el.value;
      this.implRef.verifyEmailVerificationOTP(value, this.otp,type);
    }
    
  }
  showEmailVerifyModal(){
    this.implRef.showEmailVerifyModal();
  }

  showEmailVerificationBanner(){
    this.implRef.showEmailVerificationBanner();
  }

  hideEmailVerificationBanner(){
   this.implRef.hideEmailVerificationBanner();
  }

  closeEmailVerifyModal(){
    this.userEmail.setValue('');
    this.userMobileForm.get('userMobile').setValue('');
    this.implRef.showOtpError = false;
    this.implRef.showOtpErrorMsg = " ";
    this.implRef.showInputOtpScreen= false;
    this.implRef.showValidateEmailScreen = true;
    this.implRef.isResendEmailOtp = false;
    this.implRef.enableButton = false;
    this.implRef.showsuccessullyValidatedScreen=false;
    this.implRef.hideEmailVerifyModal();
    this.universalService.isPhoneVerification = false;
    this.universalService.mobileNoVerification = false;
    this.universalService.backupNoVerification = false;
  }

  alreadyHaveOtp(type){
    if(type == 'email'){
      if(this.userEmail.valid){
        this.implRef.showOtpError = false;
        this.implRef.showOtpErrorMsg = " ";
        this.implRef.showInputOtpScreen= true;
        this.implRef.showValidateEmailScreen = false;
        this.implRef.isResendEmailOtp = false;
        this.implRef.enableButton = false;
        this.cleverTapEventsService.emailVerifyAlreadyHavOtpClicked();
      }
    }else{
      let el = document.getElementById('user-no-txtbx')as any;
      let value = el.value;
      if(regexpMobile.test(value)){
        this.implRef.showOtpError = false;
        this.implRef.showOtpErrorMsg = " ";
        this.implRef.showInputOtpScreen= true;
        this.implRef.showValidateEmailScreen = false;
        this.implRef.isResendEmailOtp = false;
        this.implRef.enableButton = false;
        this.cleverTapEventsService.emailVerifyAlreadyHavOtpClicked();
      }
    }
  }

  changeEmail(){
    this.implRef.showInputOtpScreen= false;
    this.implRef.showValidateEmailScreen = true;
    this.implRef.showOtpError = false;
    this.implRef.showOtpErrorMsg = "";
    this.implRef.isResendEmailOtp = false;
  }

  onLoading(input,type){
    if(type == 'email'){
      this.emailPattern = regexpEmail.test(input) 
      if(!this.emailPattern ||input === '' || input.length==0 || input == undefined){
        this.inputInvalid=true
      }else{
        this.inputInvalid=false
      }  
    }   
  }
  clearError(emailInput){
    this.errorMsg="";
    if(emailInput.value == "" || emailInput.value.trim().length == 0 || emailInput.value.trim().length > 100){
      this.emailPattern=false;
      this.inputInvalid=true;
    }else if(!(regexpEmail.test(this.userEmail.value)) || this.userEmail.value.length>this.maxLen){
      this.inputInvalid=true;
      this.emailPattern=false;
      this.userEmail.setValue(this.userEmail.value.substring(0, this.maxLen));
    }else{
      this.emailPattern=true;
      this.inputInvalid=false;
      this.implRef.showOtpError = false;
      this.implRef.showOtpErrorMsg = " ";
      this.implRef.isResendEmailOtp = false;
    }
  }
  clearMobileNoError(mobileInput){
    this.errorMsg="";
    let phoneno = mobileInput.value;
    if(mobileInput.value == "" || mobileInput.value.trim().length == 0 || mobileInput.value.trim().length < 10){
      this.mobilePattern=false;
      return;
    }
    this.mobilePattern = regexpMobile.test(phoneno) ;
   
    if(this.mobilePattern){//this.userEmail.valid
      this.implRef.showOtpError = false;
      this.implRef.showOtpErrorMsg = " ";
      this.implRef.isResendEmailOtp = false;
    }
    
    if(!this.mobilePattern && phoneno.length>=10){
      // this.userMobile.setValue(phoneno.substring(0, 10));
      this.userMobileForm.get('userMobile').setValue(phoneno.substring(0, 10));
    }
  }

}
